module.exports = __webpack_public_path__ + "16b39fa671f6745c3fb57a3ad934a25c.png";